import { Action, getModule, Module, Mutation, VuexModule } from 'vuex-module-decorators';
import { completeUpgrade } from '@api/ria';
import { DripStatuses } from 'types/investment-entity';
import { NextServiceLevel } from 'types/upgrade';
import { RiaPlan } from 'types/plan';
import { RiaUpgradePreference } from 'types/ria';
import store from '..';

@Module({
	dynamic: true,
	namespaced: true,
	name: 'ria-upgrade',
	store
})
class RiaUpgradeModule extends VuexModule {
	riaPlanId = '';
	reinvestmentPreference!: DripStatuses;
	suggestedServiceLevel: NextServiceLevel | null = null;
	hasSubmitted = false;

	get isServiceLevelCoreOrAbove(): boolean {
		return (
			this.suggestedServiceLevel !== null &&
			(this.suggestedServiceLevel.name === 'CORE' ||
				this.suggestedServiceLevel.name === 'ADVANCED' ||
				this.suggestedServiceLevel.name === 'PREMIUM')
		);
	}

	@Action
	public async submitPlanId(riaPlanId: string): Promise<string> {
		this.UPDATE_RIA_PLAN_ID(riaPlanId);
		return 'ria-upgrade-agreements';
	}

	@Action
	public async submitReinvestmentPreference(reinvestmentPreference: DripStatuses): Promise<string> {
		this.UPDATE_REINVESTMENT_PREFERENCE(reinvestmentPreference);
		this.UPDATE_HAS_SUBMITTED(true);
		const riaUpgradePreference: RiaUpgradePreference = {
			riaPlanId: this.riaPlanId,
			reinvestmentPreference
		};

		await completeUpgrade(riaUpgradePreference);

		return 'ria-upgrade-success';
	}

	@Action
	public async getStarterPlan(): Promise<RiaPlan> {
		return (this.suggestedServiceLevel?.riaPlans ?? []).filter((riaPlan) => riaPlan.planType === 'STARTER')[0];
	}

	@Action
	public async getBasicPlan(): Promise<RiaPlan> {
		return (this.suggestedServiceLevel?.riaPlans ?? []).filter((riaPlan) => riaPlan.planType === 'BASIC')[0];
	}

	@Action
	public async getIraPlans(): Promise<Array<RiaPlan>> {
		return (this.suggestedServiceLevel?.riaPlans ?? []).filter((riaPlan) => riaPlan.planType === 'IRA_ONLY');
	}

	@Action
	public async getPlans(): Promise<Array<RiaPlan>> {
		return (this.suggestedServiceLevel?.riaPlans ?? []).filter((riaPlan) => riaPlan.planType === 'STANDARD');
	}

	@Mutation
	public UPDATE_RIA_PLAN_ID(riaPlanId: string): void {
		this.riaPlanId = riaPlanId;
	}

	@Mutation
	public UPDATE_REINVESTMENT_PREFERENCE(reinvestmentPreference: DripStatuses): void {
		this.reinvestmentPreference = reinvestmentPreference;
	}

	@Mutation
	public UPDATE_SUGGESTED_SERVICE_LEVEL(suggestedServiceLevel: NextServiceLevel): void {
		this.suggestedServiceLevel = suggestedServiceLevel;
	}

	@Mutation
	public UPDATE_HAS_SUBMITTED(hasSubmitted: boolean): void {
		this.hasSubmitted = hasSubmitted;
	}
}

export const riaUpgrade = getModule(RiaUpgradeModule);
